import React, { useState } from 'react';
import { Container, Typography, TextField, Button, Box, Alert, Link } from '@mui/material';
import { db } from '../utils/firebase';
import { collection, addDoc } from 'firebase/firestore';

const Admin = () => {
  const [module, setModule] = useState('expense-splitter');
  const [token, setToken] = useState('');
  const [generatedUrl, setGeneratedUrl] = useState('');
  const [error, setError] = useState('');

  const generateUrl = async () => {
    const uniqueToken = Math.random().toString(36).substr(2, 9);
    try {
      await addDoc(collection(db, 'tokens'), {
        module,
        token: uniqueToken,
        used: false,
        createdAt: new Date()
      });
      const url = `${window.location.origin}/register?module=${module}&token=${uniqueToken}`;
      setGeneratedUrl(url);
      setToken(uniqueToken);
      setError('');
    } catch (err) {
      console.error('Firestore error:', err);
      setError('Failed to generate token.');
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>SuperAdmin Panel</Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Generate unique registration URLs for specific modules. Share these URLs with users to allow access.
      </Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextField
          label="Module"
          value={module}
          onChange={(e) => setModule(e.target.value)}
          fullWidth
          helperText="e.g., expense-splitter"
        />
        <Button variant="contained" color="primary" onClick={generateUrl}>
          Generate Registration URL
        </Button>
        {generatedUrl && (
          <Alert severity="success" sx={{ mt: 2 }}>
            <Typography variant="body2">
              Registration URL: <Link href={generatedUrl} target="_blank">{generatedUrl}</Link>
            </Typography>
            <Typography variant="caption">Token: {token}</Typography>
          </Alert>
        )}
      </Box>
    </Container>
  );
};

export default Admin;